import { Col, Row } from 'antd';
import Icon from '@ant-design/icons';
import RevenueChart from '../../../../../components/reusable/report/graphs/RevenueChart';
import RevenueTable from '../../../../../components/reusable/report/tables/RevenueTable';
import React from 'react';
import CompanyDataCard from '../../../../../components/reusable/CompanyDataCard';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ComposedChartIcon } from '../../../../../assets/img/icons/composedChart.svg';

const data = {
  companyCode: 111111113,
  creditinfoId: 104498,
  profits: [
    {
      financialYear: '2006-01-01T00:00:00Z',
      amount: 150000,
    },
    {
      financialYear: '2007-01-01T00:00:00Z',
      amount: 165000,
    },
    {
      financialYear: '2008-01-01T00:00:00Z',
      amount: 156426,
    },
    {
      financialYear: '2009-01-01T00:00:00Z',
      amount: 125646,
    },
    {
      financialYear: '2010-01-01T00:00:00Z',
      amount: 140000,
    },
    {
      financialYear: '2011-01-01T00:00:00Z',
      amount: 140000,
    },
    {
      financialYear: '2012-01-01T00:00:00Z',
      amount: 123354,
    },
    {
      financialYear: '2013-01-01T00:00:00Z',
      amount: 140000,
    },
    {
      financialYear: '2014-01-01T00:00:00Z',
      amount: 140000,
    },
    {
      financialYear: '2015-01-01T00:00:00Z',
      amount: 150000,
    },
    {
      financialYear: '2016-01-01T00:00:00Z',
      amount: 154561,
    },
    {
      financialYear: '2017-01-01T00:00:00Z',
      amount: 72564,
    },
    {
      financialYear: '2018-01-01T00:00:00Z',
      amount: 121000,
    },
    {
      financialYear: '2019-01-01T00:00:00Z',
      amount: 121000,
    },
    {
      financialYear: '2020-01-01T00:00:00Z',
      amount: 121000,
    },
    {
      financialYear: '2021-01-01T00:00:00Z',
      amount: 121000,
    },
    {
      financialYear: '2022-01-01T00:00:00Z',
      amount: 121000,
    },
  ],
  incomes: [
    {
      financialYear: '2006-01-01T00:00:00Z',
      amount: 185000,
    },
    {
      financialYear: '2007-01-01T00:00:00Z',
      amount: 200000,
    },
    {
      financialYear: '2008-01-01T00:00:00Z',
      amount: 165545,
    },
    {
      financialYear: '2009-01-01T00:00:00Z',
      amount: 145865,
    },
    {
      financialYear: '2010-01-01T00:00:00Z',
      amount: 175642,
    },
    {
      financialYear: '2011-01-01T00:00:00Z',
      amount: 154565,
    },
    {
      financialYear: '2012-01-01T00:00:00Z',
      amount: 145645,
    },
    {
      financialYear: '2013-01-01T00:00:00Z',
      amount: 154532,
    },
    {
      financialYear: '2014-01-01T00:00:00Z',
      amount: 175642,
    },
    {
      financialYear: '2015-01-01T00:00:00Z',
      amount: 254625,
    },
    {
      financialYear: '2016-01-01T00:00:00Z',
      amount: 240247,
    },
    {
      financialYear: '2017-01-01T00:00:00Z',
      amount: 102151,
    },
    {
      financialYear: '2018-01-01T00:00:00Z',
      amount: 278666,
    },
    {
      financialYear: '2019-01-01T00:00:00Z',
      amount: 326564,
    },
    {
      financialYear: '2020-01-01T00:00:00Z',
      amount: 275615,
    },
    {
      financialYear: '2021-01-01T00:00:00Z',
      amount: 240247,
    },
    {
      financialYear: '2022-01-01T00:00:00Z',
      amount: 321566,
    },
  ],
};

const IncomeAndProfitGraph = () => {
  const { t } = useTranslation();

  const values = data.incomes.map(({ financialYear, amount: income }) => {
    const profit =
      data.profits.find(({ financialYear: matchingYear }) => financialYear === matchingYear)?.amount ?? null;
    return { date: financialYear, income, profit };
  });

  const incomes = [
    {
      financialYear: '2018-01-01T00:00:00Z',
      amount: 5114066,
    },
    {
      financialYear: '2019-01-01T00:00:00Z',
      amount: 5301834,
    },
    {
      financialYear: '2020-01-01T00:00:00Z',
      amount: 5615175,
    },
    {
      financialYear: '2021-01-01T00:00:00Z',
      amount: 5211764,
    },
    {
      financialYear: '2022-01-01T00:00:00Z',
      amount: 5592429,
    },
  ];

  const tableData = [
    {
      2006: '143.44',
      2007: '423.34',
      2008: '509.07',
      2009: '864.00',
      2010: '1.02',
      2011: '850.28',
      2012: '1.15',
      2013: '1.57',
      2014: '408.89',
      2015: '437.96',
      2016: '202.92',
      2017: '475.41',
      2018: '260.98',
      2019: '0.00',
      2020: '0.00',
      2021: '-6.33',
      2022: '-5.32',
      income: '0 - ...',
    },
  ];

  return (
    <CompanyDataCard
      title={t('professionalReport.financialData.income.title')}
      icon={<Icon component={ComposedChartIcon} className="icon--gray" />}
      className="content-blur"
    >
      <Row className="space-vertical-md">
        <Col md={24} lg={24}>
          <RevenueChart chartData={values} />
          <RevenueTable tableData={tableData} incomes={incomes} />
        </Col>
      </Row>
    </CompanyDataCard>
  );
};

export default IncomeAndProfitGraph;
